import { render, staticRenderFns } from "./Occupation.vue?vue&type=template&id=b7062344&scoped=true"
import script from "./Occupation.vue?vue&type=script&lang=js"
export * from "./Occupation.vue?vue&type=script&lang=js"
import style0 from "./Occupation.vue?vue&type=style&index=0&id=b7062344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7062344",
  null
  
)

export default component.exports